import { logger } from '@gem/modules/logger';

import { getCommitMessages } from 'APP/Tasks/e2ee/getCommitMessages';
import { IE2eeWelcome } from 'APP/model/e2ee/e2eeModel.types';
import { e2eeModel } from 'APP/model/model';
import { MlsStorageService } from 'SERVICES/mlsStorageService/MlsStorageService';
import Entities from 'STORE';
import { SecretGroup } from 'STORE/Groups/SecretGroup/SecretGroup';

const processWelcomesAndCommits = async (welcome: IE2eeWelcome): Promise<void> => {
  const result = MlsStorageService.processWelcomeMessage(welcome);

  if (!result) {
    return;
  }
  // эпоха уже актуальная, нужны только следующие коммиты
  const afterEpoch = welcome.epoch + 1;
  await getCommitMessages(welcome.chatId, afterEpoch);
  const group = Entities.GroupsStore.getGroupById(welcome.chatId);

  if (group && group instanceof SecretGroup) {
    group.setIsUnlocked();
  }
};

export const findSecretGroupsAndLoadWelcomes = async (groupIds: string[]): Promise<void> => {
  try {
    const unloadedSecretGroupsIds: string[] = [];
    groupIds.forEach((groupId) => {
      const mlsGroup = MlsStorageService.loadGroup(groupId);

      if (!mlsGroup) {
        unloadedSecretGroupsIds.push(groupId);
      } else {
        const group = Entities.GroupsStore.getGroupById(groupId);

        if (group && group instanceof SecretGroup) {
          group.setIsUnlocked();
        }
      }
    });

    if (!unloadedSecretGroupsIds.length) {
      return;
    }

    const welcomeMessages = await e2eeModel.getWelcomes();

    if (!welcomeMessages.welcomes.length) {
      return;
    }

    const groupIdsForAck: string[] = [];
    const getWelcomesAndCommitsPromises: Promise<void>[] = [];

    welcomeMessages.welcomes.forEach((welcomeMessage) => {
      if (unloadedSecretGroupsIds.includes(welcomeMessage.chatId)) {
        groupIdsForAck.push(welcomeMessage.chatId);
        getWelcomesAndCommitsPromises.push(processWelcomesAndCommits(welcomeMessage));
      }
    });

    try {
      await Promise.all(getWelcomesAndCommitsPromises);
    } catch (error) {
      logger
        .get('Tasks')
        .error('e2ee.findSecretGroupsAndLoadWelcomes.welcomeMessages.foreach', error);
    } finally {
      await e2eeModel.ackWelcomes(groupIdsForAck);
    }
  } catch (error) {
    logger.get('Tasks').error('e2ee.findSecretGroupsAndLoadWelcomes', error);
  }
};
